/**
 * One-shot handoff from the go-to chip's "Foreslå rute hit" (spec 13) to the
 * Planner's auto-route B input (spec 09) — the documented upgrade path from
 * go-to, not a merge of the two features. `request()` stashes the point and
 * navigates to /planlegg; PlannerScreen `consume()`s it once on mount.
 */
import { create } from 'zustand';

interface AutoRouteHandoffState {
  pendingB: { lat: number; lon: number } | null;
  request: (point: { lat: number; lon: number }) => void;
  consume: () => { lat: number; lon: number } | null;
}

export const useAutoRouteHandoff = create<AutoRouteHandoffState>((set, get) => ({
  pendingB: null,
  request: (point) => set({ pendingB: point }),
  consume: () => {
    const point = get().pendingB;
    set({ pendingB: null });
    return point;
  },
}));
